var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationEvent = function SvgIllustrationEvent(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--color-disabled)",
    viewBox: "0 0 360 360",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245.4,
    cy: 253.1,
    r: 55.6,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 245.4 253)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 106.6,
    r: 55.6,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 114 106.6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m267.913 122.889 4.463-37.435 37.435 4.464-4.464 37.435zM50 276.4l8.288-36.778 36.778 8.289-8.288 36.777z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M183 95.6c-48.7 0-88.4 39-88.4 86.8A87.7 87.7 0 0 0 183 269c48.7 0 88.4-39 88.4-86.7A87.7 87.7 0 0 0 183 95.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M171.5 199.7c-2.7 0-5-1-6.9-2.8a9.3 9.3 0 0 1-2.8-6.8c0-2.7 1-5 2.8-6.9a9.3 9.3 0 0 1 6.9-2.8c2.7 0 5 1 6.8 2.8a9.3 9.3 0 0 1 2.8 6.9c0 2.7-1 5-2.8 6.8a9.3 9.3 0 0 1-6.8 2.8M156 221c-2 0-4-.8-5.4-2.3a7.4 7.4 0 0 1-2.3-5.5v-54c0-2.1.8-4 2.3-5.4a7.4 7.4 0 0 1 5.4-2.3h3.9v-3.9c0-1 .4-2 1-2.7.8-.8 1.8-1.1 2.8-1.1 1.1 0 2 .3 2.8 1 .7.8 1.1 1.7 1.1 2.8v3.9h30.9v-3.9c0-1 .4-2 1-2.7.8-.8 1.7-1.1 2.8-1.1s2 .3 2.8 1c.7.8 1.1 1.7 1.1 2.8v3.9h3.9c2 0 3.9.7 5.4 2.3a7.4 7.4 0 0 1 2.3 5.4v54c0 2.2-.8 4-2.3 5.5a7.4 7.4 0 0 1-5.4 2.3h-54Zm0-7.8h54v-38.6h-54z"
  })));
};
export default SvgIllustrationEvent;